/* 
    Put here your own custom Javascript styles, this will excute after theme.min.js
*/

//remove empty p in description
Array.from(document.querySelectorAll('.rte.product-description p')).forEach(
    (p) => {
        // const span = p.querySelector('span[data-mce-fragment]');
        if (!p.textContent.trim()) {
            p.parentNode.removeChild(p);
        }
    }
);
/* 
    Put here your own custom Javascript styles, this will excute after theme.min.js
*/

//remove empty p in description
Array.from(document.querySelectorAll('.rte.product-description p')).forEach(
    (p) => {
        // const span = p.querySelector('span[data-mce-fragment]');
        if (!p.textContent.trim()) {
            p.parentNode.removeChild(p);
        }
    }
);

$(document).ready(function () {
  const $fisButton = $(".fis-button");
  const $fisModal = $("#fis-kaya-bodysuit");
  if (!$fisButton.length || !$fisModal.length) return;

  const $fisText = $fisButton.find(".fis-text");

  // Loader element
  const $loaderSnap = $(`
    <span class="fis-loader hidden">
     <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true">
                    </span>
    </span>
  `);
  $fisText.append($loaderSnap);

  // Ensure content container exists
  let $fisContent = $fisModal.find(".fis-modal-content");
  if (!$fisContent.length) {
    $fisContent = $('<div class="grid grid--fis fis-modal-content"></div>');
    $fisModal.find(".mak-modal__inner").append($fisContent);
  }

  const $fisClose = $fisModal.find(".mak-modal__button");
  const $overlay = $fisModal.find(".mak-modal__overlay");

  // Detect current handle (URL path)
  function getHandleFromUrl() {
    const path = window.location.pathname.replace(/\/+$/, "");
    const parts = path.split("/");
    const productsIndex = parts.lastIndexOf("products");
    if (productsIndex !== -1 && parts.length > productsIndex + 1) {
      return parts[productsIndex + 1];
    }
    return parts[parts.length - 1] || "";
  }

  // ✅ Get current variant dynamically
  function getCurrentVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get("variant");
    if (variantFromUrl) return variantFromUrl;

    const $variantInput = $("form[action^='/cart/add'] input[name='id']");
    if ($variantInput.length) return $variantInput.val();

    return null;
  }

  function openModal() {
    $fisModal.addClass("modal--active");
    $("body").addClass("no-scroll");
  }

  function closeModal() {
    $fisModal.removeClass("modal--active");
    $("body").removeClass("no-scroll");
  }

  // 🔹 When clicking "Find in Boutique" button
  $fisButton.on("click", function () {
    const handle = getHandleFromUrl();
    const variantId = getCurrentVariantId();

    if (!handle) {
      alert("Error: Cannot detect product handle from URL.");
      return;
    }

    $loaderSnap.removeClass("hidden");
    $fisButton.addClass("loading");

    const url = variantId
      ? `/products/${encodeURIComponent(handle)}?variant=${variantId}&view=store_locator`
      : `/products/${encodeURIComponent(handle)}?view=store_locator`;

    fetch(url, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        $fisContent.html(html);
        openModal();

        // Disable the Add to Cart inside popup initially
        const $popupBtn = $fisContent.find(".fis-store__atc");
        $popupBtn.addClass("disabled").attr("aria-disabled", "true");

        // Enable button only when a store is selected
        $fisContent.on("change", "input[type='radio']", function () {
          if ($fisContent.find("input[type='radio']:checked").length > 0) {
            $popupBtn.removeClass("disabled").removeAttr("aria-disabled");
          }
        });

        // Handle click on popup Add to Cart
        $fisContent.on("click", ".fis-store__atc", function (e) {
          e.preventDefault();

          if ($(this).hasClass("disabled")) return; // Do nothing if disabled

          const $mainAddToCart = $(".add-to-cart-btn");
          if ($mainAddToCart.length) {
            $mainAddToCart.trigger("click");
            closeModal();
          } else {
            alert("Add to Cart button not found on page.");
          }
        });
      })
      .catch((err) => {
        console.error("❌ Store Locator load error:", err);
        $fisContent.html(`<p style="color:red;">Error loading store locator.</p>`);
        openModal();
      })
      .finally(() => {
        $loaderSnap.addClass("hidden");
        $fisButton.removeClass("loading");
      });
  });

  $fisClose.on("click", closeModal);
  $overlay.on("click", closeModal);
});

